/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Ceske_RealityInputs */

const cs_enum_ceske_reality = /** @type {(inputs: Enum_Ceske_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`České reality`)
};

const en_enum_ceske_reality = /** @type {(inputs: Enum_Ceske_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`České reality`)
};

/**
* | output |
* | --- |
* | "České reality" |
*
* @param {Enum_Ceske_RealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_ceske_reality = /** @type {((inputs?: Enum_Ceske_RealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Ceske_RealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_ceske_reality(inputs)
	return cs_enum_ceske_reality(inputs)
});